__turbopack_context__.v({
  "error": "items-form-block1440px-module-scss-module__URhSvG__error",
  "errorText": "items-form-block1440px-module-scss-module__URhSvG__errorText",
  "form": "items-form-block1440px-module-scss-module__URhSvG__form",
  "formblock": "items-form-block1440px-module-scss-module__URhSvG__formblock",
  "icon": "items-form-block1440px-module-scss-module__URhSvG__icon",
  "icon5": "items-form-block1440px-module-scss-module__URhSvG__icon5",
  "interestedInSponsorship": "items-form-block1440px-module-scss-module__URhSvG__interestedInSponsorship",
  "item1": "items-form-block1440px-module-scss-module__URhSvG__item1",
  "item11": "items-form-block1440px-module-scss-module__URhSvG__item11",
  "item2": "items-form-block1440px-module-scss-module__URhSvG__item2",
  "items": "items-form-block1440px-module-scss-module__URhSvG__items",
  "label": "items-form-block1440px-module-scss-module__URhSvG__label",
  "leftcol": "items-form-block1440px-module-scss-module__URhSvG__leftcol",
  "lookingForA": "items-form-block1440px-module-scss-module__URhSvG__lookingForA",
  "lookingformblock1440px": "items-form-block1440px-module-scss-module__URhSvG__lookingformblock1440px",
  "raceTeamImage": "items-form-block1440px-module-scss-module__URhSvG__raceTeamImage",
  "rightcol": "items-form-block1440px-module-scss-module__URhSvG__rightcol",
  "row": "items-form-block1440px-module-scss-module__URhSvG__row",
  "tellUsWhat": "items-form-block1440px-module-scss-module__URhSvG__tellUsWhat",
  "tellUsWhatContainer": "items-form-block1440px-module-scss-module__URhSvG__tellUsWhatContainer",
  "text": "items-form-block1440px-module-scss-module__URhSvG__text",
  "text1": "items-form-block1440px-module-scss-module__URhSvG__text1",
  "text6": "items-form-block1440px-module-scss-module__URhSvG__text6",
  "textField": "items-form-block1440px-module-scss-module__URhSvG__textField",
  "wrapper": "items-form-block1440px-module-scss-module__URhSvG__wrapper",
});
